// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"36":"d60e71077f48fa8c","76":"ad42dca7e61b016c","331":"f4d8977ece7e2d8e","489":"d695d9f6c36dfbe4","995":"efd3fa70ff5bccbc"}[chunkId] + ".js";
};